(() => {
  const SELECTOR =
    "[data-ineffable-gallery]";


  function initializeGallery(section) {
    if (
      !section ||
      section.dataset.galleryInitialized ===
        "true"
    ) {
      return;
    }


    section.dataset.galleryInitialized =
      "true";


    const pieces = Array.from(
      section.querySelectorAll(
        "[data-gallery-piece]"
      )
    );


    const revealElements =
      Array.from(
        section.querySelectorAll(
          "[data-gallery-room-reveal], [data-gallery-piece]"
        )
      );


    const lightbox =
      section.querySelector(
        "[data-gallery-lightbox]"
      );


    if (!lightbox) {
      return;
    }


    const image =
      lightbox.querySelector(
        "[data-gallery-lightbox-image]"
      );


    const title =
      lightbox.querySelector(
        "[data-gallery-lightbox-title]"
      );


    const category =
      lightbox.querySelector(
        "[data-gallery-lightbox-category]"
      );


    const story =
      lightbox.querySelector(
        "[data-gallery-lightbox-story]"
      );


    const year =
      lightbox.querySelector(
        "[data-gallery-lightbox-year]"
      );


    const materials =
      lightbox.querySelector(
        "[data-gallery-lightbox-materials]"
      );


    const dimensions =
      lightbox.querySelector(
        "[data-gallery-lightbox-dimensions]"
      );


    const finish =
      lightbox.querySelector(
        "[data-gallery-lightbox-finish]"
      );


    const yearWrap =
      lightbox.querySelector(
        "[data-gallery-lightbox-year-wrap]"
      );


    const materialsWrap =
      lightbox.querySelector(
        "[data-gallery-lightbox-materials-wrap]"
      );


    const dimensionsWrap =
      lightbox.querySelector(
        "[data-gallery-lightbox-dimensions-wrap]"
      );


    const finishWrap =
      lightbox.querySelector(
        "[data-gallery-lightbox-finish-wrap]"
      );


    const currentCounter =
      lightbox.querySelector(
        "[data-gallery-lightbox-current]"
      );


    const totalCounter =
      lightbox.querySelector(
        "[data-gallery-lightbox-total]"
      );


    const prevButton =
      lightbox.querySelector(
        "[data-gallery-prev]"
      );


    const nextButton =
      lightbox.querySelector(
        "[data-gallery-next]"
      );


    const closeButtons =
      Array.from(
        lightbox.querySelectorAll(
          "[data-gallery-close]"
        )
      );


    let currentIndex = 0;


    /* ==================================================
       REVEAL
       ================================================== */

    const revealAll = () => {
      revealElements.forEach(
        (element) => {
          element.classList.add(
            "is-visible"
          );
        }
      );
    };


    if (
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches
    ) {
      revealAll();
    }

    else if (
      "IntersectionObserver" in window
    ) {

      const observer =
        new IntersectionObserver(
          (entries) => {

            entries.forEach(
              (entry) => {

                if (
                  !entry.isIntersecting
                ) {
                  return;
                }


                entry.target.classList.add(
                  "is-visible"
                );


                observer.unobserve(
                  entry.target
                );

              }
            );

          },
          {
            threshold: 0.08,

            rootMargin:
              "0px 0px -6% 0px"
          }
        );


      revealElements.forEach(
        (element, index) => {

          if (
            element.matches(
              "[data-gallery-piece]"
            )
          ) {

            element.style.transitionDelay =
              `${Math.min(
                index * 55,
                330
              )}ms`;

          }


          observer.observe(
            element
          );

        }
      );

    }

    else {
      revealAll();
    }


    /* ==================================================
       COUNTER
       ================================================== */

    if (totalCounter) {
      totalCounter.textContent =
        String(
          pieces.length
        ).padStart(
          2,
          "0"
        );
    }


    /* ==================================================
       UPDATE LIGHTBOX
       ================================================== */

    function updateLightbox(index) {

      if (!pieces.length) {
        return;
      }


      currentIndex =
        (
          index +
          pieces.length
        ) %
        pieces.length;


      const piece =
        pieces[currentIndex];


      const pieceImage =
        piece.dataset.image || "";


      const pieceTitle =
        piece.dataset.title || "";


      const pieceCategory =
        piece.dataset.category || "";


      const pieceStory =
        piece.dataset.story || "";


      const pieceYear =
        piece.dataset.year || "";


      const pieceMaterials =
        piece.dataset.materials || "";


      const pieceDimensions =
        piece.dataset.dimensions || "";


      const pieceFinish =
        piece.dataset.finish || "";


      if (image) {
        image.src =
          pieceImage;

        image.alt =
          pieceTitle;
      }


      if (title) {
        title.textContent =
          pieceTitle;
      }


      if (category) {
        category.textContent =
          pieceCategory;
      }


      if (story) {
        story.textContent =
          pieceStory;
      }


      if (year) {
        year.textContent =
          pieceYear;
      }


      if (materials) {
        materials.textContent =
          pieceMaterials;
      }


      if (dimensions) {
        dimensions.textContent =
          pieceDimensions;
      }


      if (finish) {
        finish.textContent =
          pieceFinish;
      }


      if (yearWrap) {
        yearWrap.hidden =
          !pieceYear;
      }


      if (materialsWrap) {
        materialsWrap.hidden =
          !pieceMaterials;
      }


      if (dimensionsWrap) {
        dimensionsWrap.hidden =
          !pieceDimensions;
      }


      if (finishWrap) {
        finishWrap.hidden =
          !pieceFinish;
      }


      if (currentCounter) {
        currentCounter.textContent =
          String(
            currentIndex + 1
          ).padStart(
            2,
            "0"
          );
      }

    }


    /* ==================================================
       OPEN
       ================================================== */

    function openLightbox(index) {

      updateLightbox(
        index
      );


      lightbox.classList.add(
        "is-open"
      );


      lightbox.setAttribute(
        "aria-hidden",
        "false"
      );


      document.body.classList.add(
        "ineffable-gallery-lightbox-open"
      );


      lightbox
        .querySelector(
          "[data-gallery-close]"
        )
        ?.focus();

    }


    /* ==================================================
       CLOSE
       ================================================== */

    function closeLightbox() {

      lightbox.classList.remove(
        "is-open"
      );


      lightbox.setAttribute(
        "aria-hidden",
        "true"
      );


      document.body.classList.remove(
        "ineffable-gallery-lightbox-open"
      );


      pieces[currentIndex]
        ?.querySelector(
          "[data-gallery-open]"
        )
        ?.focus();

    }


    /* ==================================================
       ARTWORK CLICKS
       ================================================== */

    pieces.forEach(
      (piece, index) => {

        piece
          .querySelector(
            "[data-gallery-open]"
          )
          ?.addEventListener(
            "click",
            () => {
              openLightbox(
                index
              );
            }
          );

      }
    );


    /* ==================================================
       NAV
       ================================================== */

    prevButton?.addEventListener(
      "click",
      () => {
        updateLightbox(
          currentIndex - 1
        );
      }
    );


    nextButton?.addEventListener(
      "click",
      () => {
        updateLightbox(
          currentIndex + 1
        );
      }
    );


    closeButtons.forEach(
      (button) => {

        button.addEventListener(
          "click",
          closeLightbox
        );

      }
    );


    /* ==================================================
       KEYBOARD
       ================================================== */

    const keyHandler =
      (event) => {

        if (
          !lightbox.classList.contains(
            "is-open"
          )
        ) {
          return;
        }


        if (
          event.key ===
          "Escape"
        ) {

          closeLightbox();

        }


        if (
          event.key ===
          "ArrowLeft"
        ) {

          updateLightbox(
            currentIndex - 1
          );

        }


        if (
          event.key ===
          "ArrowRight"
        ) {

          updateLightbox(
            currentIndex + 1
          );

        }

      };


    document.addEventListener(
      "keydown",
      keyHandler
    );


    section._ineffableGalleryKeyHandler =
      keyHandler;

  }


  function initializeAll(
    root = document
  ) {

    root
      .querySelectorAll(
        SELECTOR
      )
      .forEach(
        initializeGallery
      );

  }


  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      () => {
        initializeAll();
      }
    );

  }

  else {

    initializeAll();

  }


  document.addEventListener(
    "shopify:section:load",
    (event) => {

      const section =
        event.target.matches?.(
          SELECTOR
        )
          ? event.target
          : event.target
              .querySelector?.(
                SELECTOR
              );


      if (!section) {
        return;
      }


      section.dataset.galleryInitialized =
        "false";


      initializeGallery(
        section
      );

    }
  );

})();